import React from "react"
import cx from "classnames"
import YouTube from "react-youtube"
import { Modal, Fade } from "@material-ui/core/"
import { Backdrop } from "components/backdrop"

import * as styles from "./video-modal.module.css"

export const VideoModal = ({ videoId, open, toggle }) => {
  const onReady = event => {
    // access to player in all event handlers via event.target
    event.target.playVideo()
  }

  return (
    <Modal
      // aria-labelledby="transition-modal-title"
      // aria-describedby="transition-modal-description"

      open={open}
      onClose={toggle}
      closeAfterTransition={true}
      BackdropComponent={Backdrop}
      BackdropProps={{
        active: open,
        toggle: toggle,
      }}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade
        in={open}
        timeout={{
          enter: 400,
          exit: 300,
        }}
      >
        <div className={styles.modal}>
          <button className={cx("reset", styles.closeButton)} onClick={toggle}>
            <span className="label underline-on-hover">Close X</span>
          </button>
          <div className={styles.modalContent}>
            <div className={styles.videoContainer}>
              <YouTube videoId={videoId} onReady={onReady} />
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}
